import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center ${className}`} data-id="element-152">
      <img src="https://cdn.magicpatterns.com/uploads/1jgfPEujM8WbGjAf9UGDw4/Cockrell_Custom_Repairs_Logo.png" alt="Cockrell Custom Repairs logo" className="h-12 md:h-16 w-auto object-contain" data-id="element-153" />
    </div>;
}